import http from "../config/HttpCommon";

const MainService = (lang) => {
    return http.requestGet(`/getData/${lang}`);
};
export default MainService;